<template>
    <font-awesome-icon icon="times" />
</template>

<script>
export default {
    name: "LDeselect"
};
</script>